import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { useSelector as _useSelector } from "react-redux";

export const useSelector = _useSelector;

const _useListStyles = makeStyles(
	(theme) => ({
		// main: {},
		// rowEven: { backgroundColor: red[500] },
		[theme.breakpoints.up("sm")]: {
			main: (props) => ({
				"& table td, table th": {
					whiteSpace: "nowrap",
				},
			}),
		},
		[theme.breakpoints.down("sm")]: {
			main: {
				background: theme.palette.background.default,
			},
			content: {
				background: theme.palette.background.default,
				boxShadow: "none",
			},
		},
	}),
	{ name: "RaMobileList" }
);

export const useListStyles = (sidebarOpen) => _useListStyles(sidebarOpen);

const _useDatagridStyles = makeStyles(
	(theme) => ({
		rowEven: { backgroundColor: grey[100] },
	}),
	{ name: "RaDatagrid" }
);

export const useDatagridStyles = () => _useDatagridStyles();

const _useFiltersStyles = makeStyles(
	(theme) => ({
		form: {
			"& .filter-field > div:last-child": {
				width: theme.spacing(1),
			},
		},
		[theme.breakpoints.down("sm")]: {
			form: {
				width: "100%",
				"& .filter-field": {
					flexShrink: 0,
					flexGrow: 1,
					width: "100%",
					"& .RaFilterFormInput-spacer-56": {
						display: "none",
					},
				},
			},
		},
	}),
	{ name: "RaFilters" }
);

export const useFiltersStyles = () => _useFiltersStyles();
